import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getSupabase, withTimeout } from "@/lib/hooks/api/utils";

export function useBulkUpdateTicketStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ ticketIds, status }: { ticketIds: string[]; status: string }) => {
      const supabase = getSupabase();
      const { data, error } = await withTimeout(
        supabase.from("tickets").update({ status }).in("id", ticketIds).select(),
        15000,
        "bulk update ticket status"
      );

      if (error) {
        throw new Error(error.message || "Failed to update ticket status");
      }

      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["tickets"] });
    },
  });
}

export function useBulkUpdateTicketAssignment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      ticketIds,
      assigned_to,
    }: {
      ticketIds: string[];
      assigned_to: string | null;
    }) => {
      const supabase = getSupabase();
      const { data, error } = await withTimeout(
        supabase.from("tickets").update({ assigned_to }).in("id", ticketIds).select(),
        15000,
        "bulk update ticket assignment"
      );

      if (error) {
        throw new Error(error.message || "Failed to update ticket assignment");
      }

      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["tickets"] });
    },
  });
}
